import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { AtividadeDetalhe, AtividadeGeralImagemViewModel } from 'src/app/core/models/atividade/atividade-detalhe';
import { AtividadeStatusOrigemEnum } from 'src/app/core/models/atividade/atividade-status-origem-enum';
  

@Component({
  selector: 'sgc-aditamento-detail',
  templateUrl: './aditamento-detail.component.html',
  styleUrls: ['./aditamento-detail.component.scss']
})
export class AditamentoDetailComponent implements OnInit {
  atividadeStatusOrigemEnum = AtividadeStatusOrigemEnum; 
  atividadeAddForm!: FormGroup;
  @Input() atividade!: AtividadeDetalhe;
  @Input() atividadeStatusOrigem!: AtividadeStatusOrigemEnum;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {

    this.atividadeAddForm = this.fb.group({
      idAtividadePai: [''],
      numero: [''],
      objeto: [''],
      etapa: [''],
      situacao: [''],
      demandante: [''],
      solicitante: [''],
      dataCriacao: [''],
      dataUltimaTramitacao: [''],
      valorLiberado: [''],
      valorEstado: ['']
    });

  }
 
  addAtividade(): void { }

  saveAtividade(): void { }

}

